<style lang="scss" scoped>
.slide-3 {
  background-image: url("../../../assets/module3/slide3/background-01.jpg");
  background-position: center;
  background-size: cover;
  padding-top: 100px;
  height: calc(100% - 100px);
}

.text-01 {
  position: absolute;
  left: 0;
  top: 0;
}

.page-left {
  flex-basis: 60%;
}
.page-right {
  flex-basis: 40%;
}

.heading1 {
  color: #c5d43b;
  font-size: 40px;
  transform: rotate(-5deg);
  transform-origin: 10% 0;
  margin-left: -30px;
}
.heading2 {
  font-size: 80px;
  margin-top: 50px;
}
.heading3 {
  font-size: 100px;
}
.heading4 {
  color: #09509c;
  font-size: 50px;
  width: 70%;
}

.superpower,
.heading5 {
  color: #c5d43b;
}
.heading5 {
  width: 40%;
  font-size: 40px;
}
.footer {
  margin-top: 310px;
  margin-left: 60px;
}
.footer-copy {
  position: absolute;
  left: 25%;
  top: -40px;
  position: relative;
  width: 500px;
  margin-bottom: 0;
  line-height: 30px;
}
.copy1 {
  font-size: 30px;
  font-family: "Comfortaa-FAST";
}
p {
  color: white;
}
.wobbly-text {
  display: flex;
  flex-direction: column;
  left: 100px;
  top: 460px;
  position: absolute;
}
.wobbly {
  color: white !important;
  font-size: 34px;
  margin-bottom: 35px;
  letter-spacing: 1.5px;
}
.wobbly-2 {
  letter-spacing: 1.5px;
  color: #c5d43b !important;
  font-family: "Kookycat-FASTcaps";
  transform: translate(-50px, -30px);
}
.wobbly-3 {
  color: white !important;
  font-size: 34px;
  margin-bottom: 50px;
  letter-spacing: 1.5px;
  transform: translate(-50px, 0px);
}
</style>

<template>
  <div class="slide-3">
    <transition name="fadeLeft" appear>
      <div class="wobbly-text delay-3" v-show="slideIndex == 2">
        <Wobbly
          class="wobbly"
          text="My superpower lies in my"
          :peak="50"
          :period="10"
          :shift="35"
        ></Wobbly>
        <Wobbly
          class="wobbly-2"
          text="super strong arms"
          :peak="30"
          :period="3"
          :shift="6"
        ></Wobbly>
        <Wobbly
          class="wobbly-3"
          text="I can lift cars and even entire houses with these two hands."
          :peak="45"
          :period="10"
          :shift="30"
        ></Wobbly>
      </div>
    </transition>
    <!-- <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 2"
        src="@/assets/module3/slide3/text-01.png"
        class="delay-3 text-01"
      />
    </transition> -->
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <h1
            class="heading1"
            v-html="$t('module3.slide3.heading1')"
            v-show="slideIndex == 2"
          ></h1>
        </transition>
        <transition name="fadeLeft" appear>
          <h1 class="heading2 delay-1" v-show="slideIndex == 2">
            {{ $t("module3.slide3.heading2") }}
            <span class="superpower">{{ $t("module3.slide3.heading3") }}</span>
            {{ $t("module3.slide3.heading4") }}
          </h1>
        </transition>

        <!-- <transition name="fadeLeft" appear>
          <h1
            class="heading3 delay-2"
            v-html="$t('module3.slide3.heading3')"
            v-show="slideIndex == 2"
          ></h1>
        </transition> -->
        <div class="footer">
          <transition name="fadeLeft" appear>
            <h1
              class="heading5 delay-3"
              v-html="$t('module3.slide3.heading5')"
              v-show="slideIndex == 2"
            ></h1>
          </transition>
          <transition name="fadeLeft" appear>
            <div class="footer-copy delay-4" v-show="slideIndex == 2">
              <h1 class="heading6">
                {{ $t("module3.slide3.heading6") }}
                <span class="copy1" v-html="$t('module3.slide3.copy1')"></span>
              </h1>
            </div>
          </transition>
        </div>
      </div>
      <div class="page page-right">
        <transition name="fadeUp" appear>
          <img
            v-show="slideIndex == 2"
            src="@/assets/module3/slide3/armando-01.png"
            class="chars delay-6"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Wobbly from "@/components/Wobbly";

export default {
  props: ["slideIndex"],
  components: {
    Wobbly
  }
};
</script>
